import React, { useEffect, useRef, useState } from "react";
import { Col, DatePicker, Row, Select, Table } from "antd";

import { useLocation, useNavigate } from "react-router-dom";
import {
  ageAssessmentBasePath,
  errorRequestHandel,
  formateDateAndTime,
  renderCaseStatusTextAndBgColor,
} from "../../../helper";
import { useDispatch, useSelector } from "react-redux";
import {
  _setProjectTab,
  _toggleEditProjectState,
  _toogleCasesActiveTab,
} from "../../../redux/actions/generalAction";
import { dentalIcons } from "../../../dentail-indetifcation/utils-icons/dentalIcons";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import CustomSpinner from "../../../dentail-indetifcation/components/d-reusable/CustomSpiner";
import CustomSearchInput from "../../../dentail-indetifcation/components/d-reusable/CustomSearchInput";
import CustomFilter from "../../../dentail-indetifcation/components/d-reusable/CustomFilter";
import TitleWithIconLink from "../../../dentail-indetifcation/components/d-reusable/TitleWithIconLink";
import { assessmentIcons } from "../../utils/assessmentIcons";
import { getCollaborationsCases } from "../../../components/https/age-assessment-apis";
import { _onResetCaseRegistrationForm } from "../../../redux/actions/age-assessment/caseRegistrationAction";

const { Option } = Select;

const filters = [
  {
    id: 1,
    title: "All",
    value: "all",
  },
  {
    id: 2,
    title: "New",
    value: "new",
  },
  {
    id: 3,
    title: "Completed",
    value: "completed",
  },
];

const AgeAssessmentCases = () => {
  const pageRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectdCasesActiveTab = useSelector(
    (state) => state.general?.selectdCasesActiveTab || "all"
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchKey, setSearchKey] = useState("");
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const location = useLocation();

  const handleSearch = (el) => {
    setSearchKey(el);
  };
  const onSearchEnter = () => {
    setSearch(searchKey);
  };
  useEffect(() => {
    pageRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [location]);

  useEffect(() => {
    getAllPorjects();
  }, [selectdCasesActiveTab]);

  const getAllPorjects = async () => {
    try {
      setLoading(true);
      const response = await getCollaborationsCases();
      if (response.status === 200) {
        const rawData = { ...response.data.data }; // create a shallow copy
        delete rawData.in_progress; // remove the key entirely
        // Ensure all items in `completed` have status === "completed"
        if (Array.isArray(rawData.completed)) {
          rawData.completed = rawData.completed.map((project) => ({
            ...project,
            status:
              project.status !== "completed" ? "completed" : project.status,
          }));
        }
        setData(rawData);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const onCreateNewProject = () => {
    dispatch(_onResetCaseRegistrationForm());

    navigate(`${ageAssessmentBasePath}/cases/new-case`);
  };

  const handleOpenSingleCaseDetail = (record) => {
    navigate(`${ageAssessmentBasePath}/cases/details`, {
      state: { projectId: record.id },
    });
  };

  const filterProjects = (projects) => {
    const normalizedSearchKey = searchKey?.toLowerCase().trim();
    const selectedDateStr = selectedDate
      ? new Date(selectedDate).toDateString()
      : null;

    return projects.filter((project) => {
      const name = project.name?.toLowerCase() || "";
      const description = project.description?.toLowerCase() || "";
      const caseNo = project.case_no?.toLowerCase() || "";

      const matchesText =
        !normalizedSearchKey ||
        name.includes(normalizedSearchKey) ||
        description.includes(normalizedSearchKey) ||
        caseNo.includes(normalizedSearchKey);

      const projectDateStr = project.created_at
        ? new Date(project.created_at).toDateString()
        : null;

      const matchesDate =
        !selectedDateStr || projectDateStr === selectedDateStr;

      return matchesText && matchesDate;
    });
  };

  // Determine data to display based on selected tab
  const projectsData = filterProjects(
    selectdCasesActiveTab === "all"
      ? [
          ...(data?.new || []),
          ...(data?.in_progress || []),
          ...(data?.completed || []),
        ]
      : data?.[selectdCasesActiveTab] || []
  );

  return (
    <CustomCard>
      <CustomSpinner loading={loading} />

      <div className="custom_rounded_padding" ref={pageRef}>
        <div className="d-project_filter_section">
          <CustomFilter
            onSelect={(value) => dispatch(_toogleCasesActiveTab(value))}
            filtersData={filters}
            selectedTab={selectdCasesActiveTab}
            customClass="custom-width"
          />

          <div className="d-project_filter_section__create_new">
            <TitleWithIconLink
              linkText={"New Exam"}
              icon={dentalIcons.rounderPlusIcon}
              linkUrl={onCreateNewProject}
              isDirty={true}
            />
          </div>
        </div>
        <Row align={"middle"} gutter={[10, 10]}>
          <Col md={4} xs={24}>
            <DatePicker
              style={{ width: "100%" }}
              placeholder="Filter by date"
              value={selectedDate}
              onChange={(date) => setSelectedDate(date)}
            />
          </Col>
          <Col md={6} xs={24}>
            <CustomSearchInput
              onSearch={handleSearch}
              search={searchKey}
              onSearchEnter={onSearchEnter}
            />
          </Col>
        </Row>

        <Table
          dataSource={projectsData}
          style={{ overflowX: "scroll" }}
          pagination={false}
          columns={[
            {
              title: "Case Number",
              key: "case_no",
              render: (text, record) => {
                return (
                  <div
                    style={{ display: "flex", gap: 20, alignItems: "center" }}
                  >
                    <img src={assessmentIcons.caseNumberIcon} />
                    <div className="custom_table_row_data">
                      <p className="_id">{record?.case_no}</p>
                    </div>
                  </div>
                );
              },
            },
            {
              title: "Name",
              dataIndex: "name",
              key: "name",
            },

            {
              title: "Registration Date",
              key: "created_at",
              render: (text, record) =>
                formateDateAndTime(record.created_at, "DD MMM YYYY"),
            },

            {
              title: <div className="custom_header_col">Status</div>,
              key: "status",
              render: (text, record) => {
                const bgColor = renderCaseStatusTextAndBgColor(record?.status);

                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        background: bgColor,
                        padding: "1px 10px",
                        textAlign: "center",
                        borderRadius: 10,
                        color: "#FFFFFF",
                        textTransform: "capitalize",
                        fontSize: 12,
                        fontFamily: "Poppins-Regular",
                        fontWeight: "500",
                      }}
                    >
                      {record.status === "in_progress"
                        ? "In Progress"
                        : record.status}
                    </div>
                  </div>
                );
              },
            },

            {
              title: "Action",
              key: "action",
              align: "center",
              render: (t, record) => {
                return (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#20C3FF",
                    }}
                    onClick={() => handleOpenSingleCaseDetail(record)}
                  >
                    View Details
                  </div>
                );
              },
            },
          ]}
        />
      </div>
    </CustomCard>
  );
};

export default AgeAssessmentCases;
